
import Statistics from './statistics';

export default Statistics
